import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryBar from "./components/CategoryBar";
import DailyDealsSection from "./components/DailyDealsSection";
import CategoriesSection from "./components/CategoriesSection";
import FeaturedProducts from "./components/FeaturedProducts";
import SEOArticles from "./components/SEOArticles";
import TrustSection from "./components/TrustSection";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { usePageSeo } from "@/hooks/usePageSeo";

export default function Home() {
  const { settings } = useSiteSettings();

  usePageSeo({
    title: `${settings.siteName} | ${settings.slogan}`,
    description: settings.seoDescription,
    canonicalPath: "/",
    keywords: settings.seoKeywords,
    image: settings.logoUrl,
    siteName: settings.siteName,
    ogType: "website",
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryBar />
        <DailyDealsSection />
        <FeaturedProducts />
        <TrustSection />
        <CategoriesSection />
        <SEOArticles />
      </main>
      <Footer />
    </div>
  );
}